module.exports = __webpack_public_path__ + "img/w6-b3.93aaf25f.jpg";